import classNames from 'classnames'
import * as React from 'react'

import {makeEditable} from '@/common/utils'
import Buttons from '@/components/Buttons'
import Image from '@/components/Image'
const Logos = ({backgroundColors, logos, buttons, _editable}) => {
  return (
    <section
      {...makeEditable(_editable)}
      className={classNames('px-2 py-22 lg:py-30', backgroundColors.current)}
    >
      {logos.length > 0 && (
        <div className='flex !grid-cols-3 flex-wrap justify-center gap-y-4 md:!grid-cols-5 lg:gap-x-2'>
          {logos.map((item, index) => {
            return (
              <div
                key={`${item._uid}_${index}`}
                className={classNames(
                  'aspect-w-176 aspect-h-64 w-1/3 text-center md:w-[20%] lg:max-w-[176px]',
                  {
                    'max-md:hidden': index > 2,
                  }
                )}
              >
                <Image
                  {...makeEditable(_editable)}
                  {...item}
                  sizes={{sm: 33, md: 20}}
                  fitIn
                  ratio='176:64'
                  className='m-auto'
                />
              </div>
            )
          })}
        </div>
      )}
      {buttons && buttons.length > 0 && (
        <div className='col-span-full pt-10'>
          <Buttons buttons={buttons} className='flex items-center justify-center gap-4' />
        </div>
      )}
    </section>
  )
}

export default Logos
